<template>
  <div class="wrapper">
    <!-- Header -->
    <header class="py-3">
      <h2 class="mb-0 text-white text-center">Pregnancy</h2>
    </header>

    <!-- Main Content -->
    <div class="container py-4">
      <div class="row mb-5 align-items-center">
        <!-- Left Panel -->
        <div class="col-sm-5">
          <div class="animated-card mb-3" :class="{ 'slide-in': isAnimated }">
            <div class="text-center">
              <img
                :src="selectedVaccine?.imgPath || '@/assets/default.png'"
                :alt="selectedVaccine?.name || 'Vaccine'"
                class="img-fluid mb-2"
              />
            </div>
          </div>

          <div class="animated-card" :class="{ 'slide-in': isAnimated }">
            <div class="text-center">
              <img
                src="@/assets/page5/Asset2.png"
                alt="Pregnancy"
                class="img-fluid mb-2"
              />
            </div>
          </div>
        </div>

        <!-- Right Panel -->
        <div class="col-sm-7">
          <div class="row g-3">
            <div
              v-for="(value, key) in selectedVaccine.ModalData"
              :key="key"
              class="col-md-12 animated-card"
              role="button"
              :class="{ 'slide-in': isAnimated }"
              @click="openModal(key, value)"
            >
              <div class="text-center">
                <img
                  :src="getImageForKey(key)"
                  :alt="getDisplayKey(key)"
                  class="img-fluid mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Banner -->
      <div class="text-center mt-5 lower-panner">
        <img
          src="@/assets/page5/panner.png"
          alt="Lower Banner"
          class="img-fluid mx-auto d-block"
        />
      </div>
      <div class="text-center mt-4 lower-panner">
        <img
          src="@/assets/page4/lowererPanner.png"
          alt="Lower Banner"
          class="img-fluid mx-auto d-block"
        />
      </div>
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation :prevRoute="'/pregHome'" :nextRoute="'/secondPregHome'" /> -->
    <!-- Reusable Modal -->
    <ReusableModal
      :isVisible="isModalVisible"
      :title="modalTitle"
      :text="modalText"
      @close="isModalVisible = false"
    />
  </div>
</template>

<script setup>
// import FooterNavigation from "@/components/FooterNavigation.vue";
import { ref, onMounted, computed } from "vue";
import ReusableModal from "@/components/ReusableModal.vue";
import { useRoute } from "vue-router";

// State for animation
const isAnimated = ref(false);
const isModalVisible = ref(false);
const modalTitle = ref("");
const modalText = ref("");
const route = useRoute();

// Open modal function
const openModal = (key, value) => {
  let titleToDisplay = key;

  // Special case for VaccinesNotRecommended
  if (selectedVaccine.value?.name === "VaccinesNotRecommended") {
    const keyMapping = {
      Indications: "Contraindicated",
      Administration: "Not recommended",
      Contraindications: "No recommendations",
    };
    titleToDisplay = keyMapping[key] || key;
  }

  modalTitle.value = titleToDisplay;
  modalText.value = value;
  isModalVisible.value = true;
};
const buttons = [
  {
    imgPath: require("@/assets/page4/Asset1.png"),
    name: "Influenza",
    route: "/secondPregHome",
    ModalData: {
      Indications: "All persons ≥6 months",
      Administration: "One dose every year, preferred before the winter season",
      Contraindications: `Previous severe allergic reaction </br>
                          Precautions 
                          Moderate or severe acute illness with or without fever.`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset2.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
    ModalData: {
      Indications: "no data",
      Administration: "no data",
      Contraindications: `no data`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset3.png"),
    name: "Tetanus",
    route: "/secondPregHome",
    ModalData: {
      Indications:
        "1 dose Tdap during each pregnancy,preferably in early part of gestational weeks 27–36.",
      Administration: "1 dose IM injection.",
      Contraindications: `Previous severe allergic reaction to a vaccine component or to a prior dose. History of encephalopathy not attributable to an identifiable cause, within 7ds following DTP/DTaP, or Tdap.`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset4.png"),
    name: "COVID-19",
    route: "/secondPregHome",
    ModalData: {
      Indications:
        "Pregnant women should receive a recommended updated COVID-19 vaccine dose at any stage of pregnancy.",
      Administration: "1 dose \n IM injection.",
      Contraindications: `History of a severe allergic reaction (e.g., anaphylaxis) after a previous dose or to a component of the COVID-19 vaccine
.`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset5.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
    ModalData: {
      Indications: "no data",
      Administration: "no data",
      Contraindications: `no data`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset6.png"),
    name: "RSV",
    route: "/secondPregHome",
    ModalData: {
      Indications: "Adults ≥60 years (IM)",
      Administration: "1 dose",
      Contraindications: `Patients with a known allergy to components of the vaccine.`,
    },
  },
  {
    imgPath: require("@/assets/page4/Asset7.png"),
    name: "HepatitisA",
    route: "/secondPregHome",
    ModalData: {
      Indications: `All adults seeking protection from (HAV) infection and persons with other risk factors (e.g., traveling to countries with high or intermediate rates, have ch. Liver dis or clotting factor disorders, illicit drug users, with recent exposure as post exposure prophylaxis)`,
      Administration:
        "A 2-dose schedule with a minimum of 6 months interval IM injection. Base decision on risk vs. benefit.",
      Contraindications: `Previous severe allergic reaction.</br>
      Precautions: </br>
Moderate or severe acute illness.`,
    },
  },

  {
    imgPath: require("@/assets/page4/Asset9.png"),
    name: "HepatitisB",
    route: "/secondPregHome",
    ModalData: {
      Indications:
        "Recommended if some other risk factor is present (e.g., on the basis of medical, occupational, lifestyle, or other indications).",
      Administration: `3-doses series at 0, 1 and 6 month intervals
(the 2nd dose should be at least 4wks after the 1st dose and the 3rd dose should be at least 8wks after the 2nd dose and at least 16wks after the 1st dose).`,
      Contraindications: `Previous severe allergic reaction
                          </br>
                          Precautions
                          Moderate or severe acute illness with or without fever.`,
    },
  },
  // {
  //   imgPath: require("@/assets/page4/asset13.png"),
  //   name: "VaccinesNotRecommended",
  //   route: "/secondPregHome",
  //   ModalData: {
  //     Indications: "no data",
  //     Administration: "no data",
  //     Contraindications: `no data`,
  //   },
  // },
  {
    imgPath: require("@/assets/page4/asset15.png"),
    name: "VaccinesNotRecommended",
    route: "/secondPregHome",
    ModalData: {
      Indications: `Measles, Mumps, Rubella (MMR),Varicella,BCG,Typhoid live vaccines like Ty21a.`,
      Administration: `Human Papillomavirus (HPV).`,
      Contraindications: `Pneumococcal Conjugate.`,
    },
  },

  {
    imgPath: require("@/assets/page4/Asset5.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
    ModalData: {
      Indications: "no data",
      Administration: "no data",
      Contraindications: `no data`,
    },
  },
  {
    imgPath: require("@/assets/page4/asset13.png"),
    name: "TravelvaccinesduringPregnancy",
    route: "/secondPregHome",
    ModalData: {
      Indications: " no data",
      Administration: "no data",
      Contraindications: `no data`,
    },
  },
];
// Compute the selected vaccine based on the route parameter
const selectedVaccine = computed(() =>
  buttons.find((vaccine) => vaccine.name === route.params.name)
);

const getImageForKey = (key) => {
  // Default images
  const defaultImages = {
    Indications: require("@/assets/page5/Layer 1.png"),
    Administration: require("@/assets/page5/Layer 2.png"),
    Contraindications: require("@/assets/page5/Layer 3.png"),
  };

  // Special images for VaccinesNotRecommended
  const specialImages = {
    Indications: require("@/assets/page5/special1.png"),
    Administration: require("@/assets/page5/special2.png"),
    Contraindications: require("@/assets/page5/special3.png"),
  };

  if (selectedVaccine.value?.name === "VaccinesNotRecommended") {
    return specialImages[key] || "@/assets/default.png";
  }

  return defaultImages[key] || "@/assets/default.png";
};
const getDisplayKey = (key) => {
  if (selectedVaccine.value?.name === "VaccinesNotRecommended") {
    const keyMapping = {
      Indications: "Contraindicated",
      Administration: "Not recommended",
      Contraindications: "No recommendations",
    };
    return keyMapping[key] || key;
  }
  return key;
};

onMounted(() => {
  // Trigger animation on mount
  setTimeout(() => {
    isAnimated.value = true;
  }, 100);
});
</script>

<style scoped>
.wrapper {
  background-color: #f5f9fc;
  min-height: 100vh;
}

header {
  background-color: #2c4fa1;
}

.animated-card {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.6s ease;
}

.animated-card.slide-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
